import { z } from "zod";

export const relatedArtistSchema = z.object({
  id: z.string(),
  name: z.string(),
  uri: z.string().nullish(),
  imageUrl: z.string().nullish(),
});
